import { VoteQuestionType } from '@hglobal/surveys';

export const VOTE_QUESTIONS_WITH_IMAGE = [
  VoteQuestionType.RADIO_WITH_IMAGE,
  VoteQuestionType.CHECKBOX_WITH_IMAGE,
];

export const VOTE_QUESTIONS_WITH_MULTIPLE_ANSWERS = [
  VoteQuestionType.CHECKBOX,
  VoteQuestionType.CHECKBOX_WITH_IMAGE,
];
